import { Options } from 'vue-class-component';
import {
  ComponentType,
  DeviceDTO,
  DevicesFilterByType,
  SlotStatus,
} from '@/../client-generator/generated-clients/plants';
import plantsClient from '@/core/services/plants';
import AddDeviceToLinkableObject from '@/views/components/AddDeviceToLinkableObject/AddDeviceToLinkableObject.vue';
import { SET_APP_LOADING } from '@/core/store/action-types';
import { HANDLE_REFRESH_PLANT } from '@/core/utils/emitter-events';
import ThermoGeneralStep from '../ThermoGeneralStep';

@Options({
  name: 'Step2AssignTheProbe',
  components: {
    AddDeviceToLinkableObject,
  },
  watch: {
    atLeastOneDeviceSelected: function () {
      this.validateNextEnabled();
    },
  },
})
export default class Step2AssignTheProbe extends ThermoGeneralStep {
  devicesProbesTmp: DeviceDTO[] = [];

  get currentDevicesProbes() {
    return this.roomObject.devices?.filter(
      (x) =>
        x.isThermoProbeDevice &&
        x.slots?.some((x) => x.assignedComponentType == ComponentType.Probe)
    );
  }

  get devicesProbes() {
    return this.devicesProbesTmp.filter(
      (x) => !this.roomObject.devices?.some((k) => k.id === x.id)
    );
  }

  created() {
    this.nextEnabled = true;
  }

  async mounted() {
    this.$store.dispatch(SET_APP_LOADING, true);

    try {
      this.devicesProbesTmp = (
        await plantsClient.devices(
          this.plantId,
          this.roomId,
          this.roomObject.id ?? '',
          DevicesFilterByType.THERMO_PROBE,
          undefined,
          this.roomObject.heatingSystemControlType || undefined,
          this.roomObject.coolingSystemControlType || undefined,
          this.roomObject.sharedSystemControlType || undefined
        )
      ).filter(
        (x) =>
          x.slots != null &&
          x.slots[0].status != undefined &&
          ![SlotStatus.MarkedForLinking, SlotStatus.Configured].includes(
            x.slots[0].status //already used as thermostat
          )
      );
    } catch (error) {
      let messageError = '';

      switch (error.status) {
        case 409:
          this.$emitter.emit(HANDLE_REFRESH_PLANT);
          this.$router.push({
            name: 'page-plant-dashboard',
            params: this.$route.params,
          });
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      if (messageError) {
        this.$toast.add({
          severity: 'error',
          summary: this.$t('general.operationError'),
          closable: true,
          life: 3000,
        });
      }
    } finally {
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }
}
